<template>
  <div>
    <SidebarVue ref="sidebar" />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="' Administração - Desk'"
      :titulo="'desk gerente'"
    />

    <!-- Fila de vendedores -->
    <div class="card-container">
      <div class="card card-table-txt">
        <nav class="navbar navbar-atend">
          <div class="container-fluid">
            <div class="row g-2">
              <div class="card-title gy-4">
                <i class="bi bi-list-ul fs-5 icon-text-form"></i>
                <span class="txt-title-form">Fila de Atendimento</span>
              </div>
            </div>
          </div>
        </nav>

        <!-- Mobile -->
        <div class="d-lg-none">
          <DraggableTableVueMob
            :usuarios="usuarios_dispo"
            @update:usuarios="atualizarLista"
            @reordenado="salvarOrdenacao"
            @pausar="abrirModalPausarVendedor"
            @despausar="abrirModalDespausarVendedor"
            @reordenacao-bloqueada="avisarReordenacaoPausado"
          />
        </div>

        <!-- Tablet (768px-992px) -->
        <div class="d-none d-lg-block d-xl-none">
          <div class="list-group">
            <div
              v-for="(vendedor, index) in usuarios_dispo"
              :key="vendedor.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center">
                <span class="badge bg-secondary me-2">{{ index + 1 }}</span>
                <div>
                  <h6 class="mb-0">{{ vendedor.username }}</h6>
                  <small class="text-muted">{{ vendedor.email }}</small>
                </div>
              </div>
              <div class="d-flex gap-1">
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="moverCima(vendedor.id)"
                >
                  <i class="bi bi-arrow-up"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="moverBaixo(vendedor.id)"
                >
                  <i class="bi bi-arrow-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <div class="d-none d-xl-block">
          <DraggableTableVue
            :usuarios="usuarios_dispo"
            @update:usuarios="atualizarLista"
            @reordenado="salvarOrdenacao"
            @pausar="abrirModalPausarVendedor"
            @despausar="abrirModalDespausarVendedor"
            @reordenacao-bloqueada="avisarReordenacaoPausado"
          />
        </div>
      </div>
    </div>

    <!-- Atendimentos -->
    <div class="card-container">
      <div class="card txt-title-table-desk">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-car-front fs-5 icon-text-logout"></i>
            <span class="txt-title-form">Atendimentos Realizados</span>
          </div>
        </div>

        <!-- Sistema de Filtros Unificado -->
        <div class="p-2">
          <div class="row g-2 align-items-center">
            <!-- Select de Filtro -->
            <div
              :class="
                selectedFilter === 'Pesquisar por Período'
                  ? 'col-12 col-md-4'
                  : 'col-12'
              "
            >
              <select
                class="form-select"
                v-model="selectedFilter"
                @change="filtrarPropostas()"
              >
                <option value="">Selecione um filtro</option>
                <option value="Dia">Diário</option>
                <option value="Todos">Todos</option>
                <option value="Em Atendimento">Em Atendimento</option>
                <option value="Venda Finalizada">Venda Finalizada</option>
                <option value="Venda Perdida">Venda Perdida</option>
                <option value="Pesquisar por Período">
                  Pesquisar por Período
                </option>
              </select>
            </div>

            <!-- Datas - Aparece apenas quando selecionado -->
            <div
              v-if="selectedFilter === 'Pesquisar por Período'"
              class="col-12 col-md-8 mt-2 mt-md-0"
            >
              <div class="row g-2 align-items-center">
                <!-- Data Inicial -->
                <div class="col-12 col-md-4">
                  <div class="input-group">
                    <span class="input-group-text d-none d-sm-inline">
                      <i class="bi bi-calendar"></i>
                    </span>
                    <input
                      type="date"
                      class="form-control"
                      v-model="startDate"
                      :max="endDate || ''"
                    />
                  </div>
                </div>

                <!-- Separador -->
                <div
                  class="col-auto text-center small text-muted d-none d-sm-block"
                >
                  até
                </div>
                <div class="col-12 d-sm-none text-center small text-muted">
                  até
                </div>

                <!-- Data Final -->
                <div class="col-12 col-md-4 mt-2 mt-md-0">
                  <div class="input-group">
                    <span class="input-group-text d-none d-sm-inline">
                      <i class="bi bi-calendar"></i>
                    </span>
                    <input
                      type="date"
                      class="form-control"
                      v-model="endDate"
                      :min="startDate || ''"
                    />
                  </div>
                </div>

                <!-- Botão Filtrar -->
                <div class="col-12 col-md-3 col-lg-2 mt-2 mt-md-0">
                  <button
                    class="btn btn-modal w-100 d-flex align-items-center justify-content-center gap-2"
                    @click="filterByPeriod"
                  >
                    <i class="bi bi-funnel-fill"></i>
                    <span class="d-none d-md-inline">Filtrar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile: Accordion - VERSÃO COMPLETA CORRIGIDA -->
        <div class="d-md-none">
          <div
            v-for="item in propostas_at"
            :key="item.id"
            class="accordion mb-2"
          >
            <div class="accordion-item">
              <button
                class="accordion-button collapsed d-flex flex-column align-items-start card-table-txt"
                data-bs-toggle="collapse"
                :data-bs-target="'#row-' + item.id"
                :class="{
                  cor_venda_finalizada_mob: item.status === 'Venda Finalizada',
                  cor_venda_perdida_mob: item.status === 'Venda Perdida',
                  cor_aguardando_aprovacao_mob:
                    item.status === 'Aguardando Aprovação',
                  cor_em_atendimento_mob: item.status === 'Atendimento',
                  cor_atendimento_apos_45_mob:
                    item.status === 'Atendimento Excedido',
                  cor_aguardando_atendimento_mob:
                    item.status === 'Aguardando Atendimento',
                  cor_atendimento_agendado_mob:
                    item.status === 'Atendimento Agendado',
                  cor_fila_mob: item.status === 'Fila de Espera'
                }"
              >
                <strong>Nº Atendimento:</strong>
                <span>{{ item.id }}</span>
              </button>
              <div :id="'row-' + item.id" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p class="card-table-item">
                    <strong>Vendedor:</strong>
                    {{ item.vendedor }}
                  </p>
                  <p class="card-table-item">
                    <strong>Cliente:</strong>
                    {{ item.cliente }}
                  </p>
                  <p class="card-table-item">
                    <strong>Modelo:</strong>
                    {{ item.modelo }}
                  </p>
                  <p class="card-table-item">
                    <strong>Total Atendimento</strong>
                    {{ item.total_atendimento }}
                  </p>
                  <p class="card-table-item">
                    <strong>Data do Atendimento:</strong>
                    {{ item.data_atendimento }}
                  </p>
                  <p class="card-table-item">
                    <strong>Menus Gerados:</strong>
                    {{ item.quantidade_proposta_menu }}
                  </p>
                  <p class="card-table-item">
                    <strong>Retorno:</strong>
                    {{ item.retorno }}
                  </p>
                  <p class="card-table-item">
                    <strong>Status:</strong>
                    {{ item.status }}
                  </p>
                  <div class="d-flex">
                    <!-- 1. Abrir Proposta -->
                    <button
                      class="btn round-btn"
                      v-bind:disabled="
                        item.status === 'Venda Finalizada' ||
                        item.status === 'Venda Perdida' ||
                        item.status === 'Aguardando Aprovação' ||
                        item.status === 'Fila de Espera'
                      "
                      @click="abrir_proposta(item.id)"
                      title="Abrir Proposta"
                    >
                      <i class="bi bi-plus-circle"></i>
                    </button>

                    <button
                      v-if="statusPermiteLiberarVendedor(item)"
                      type="button"
                      class="btn round-btn"
                      :disabled="vendedorJaLiberado(item)"
                      @click="abrirModalLiberarVendedor(item)"
                      :title="tituloLiberarVendedor(item)"
                    >
                      <i class="bi bi-unlock"></i>
                    </button>

                    <!-- 2. Informações do DES -->
                    <!-- <button
                      type="button"
                      class="btn round-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#infoDes"
                      :disabled="!item.cpfCnpj"
                      @click="info_des(item)"
                      title="Informações do Des"
                    >
                      <i class="bi bi-person-vcard-fill"></i>
                    </button> -->

                    <!-- 3. Reimprimir Menu - VERSÃO CORRIGIDA -->
                    <!-- Botão ATIVO quando pode reimprimir -->
                    <button
                      v-if="podeReimprimir(item)"
                      class="btn round-btn"
                      title="Reimprimir"
                    >
                      <router-link
                        class="nav-link active d-flex align-items-center justify-content-center"
                        :to="`/desk/menu/reimprimirGerente/${item.id}`"
                        style="color: inherit"
                      >
                        <i class="bi bi-printer"></i>
                      </router-link>
                    </button>

                    <!-- Botão DESABILITADO quando não pode reimprimir -->
                    <button
                      v-else
                      class="btn round-btn"
                      disabled
                      :title="getMensagemReimpressao(item)"
                      style="opacity: 0.5; cursor: not-allowed"
                    >
                      <i class="bi bi-printer"></i>
                    </button>

                    <!-- 4. Trocar Vendedor -->
                    <button
                      type="button"
                      class="btn round-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#trocarVendedor"
                      v-bind:disabled="
                        item.status === 'Venda Finalizada' ||
                        item.status === 'Venda Perdida' ||
                        item.status === 'Fila de Espera' ||
                        item.status === 'Atendimento Agendado'
                      "
                      @click="listar_vendedores(item)"
                      title="Trocar Vendedor"
                    >
                      <i class="bi bi-person-bounding-box"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tablet (768px-992px): Tabela Simplificada - CORRIGIDO -->
        <div class="d-none d-md-block d-lg-none">
          <div class="table-responsive">
            <table class="table table-sm card-table-txt">
              <thead class="table-light">
                <tr>
                  <th>Nº</th>
                  <th>Cliente</th>
                  <th>Modelo</th>
                  <th>Status</th>
                  <th>Total</th>
                  <th>Data</th>
                  <th class="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in propostas_at"
                  :key="item.id"
                  :class="{
                    cor_venda_finalizada_mob:
                      item.status === 'Venda Finalizada',
                    cor_venda_perdida_mob: item.status === 'Venda Perdida',
                    cor_aguardando_aprovacao_mob:
                      item.status === 'Aguardando Aprovação',
                    cor_em_atendimento_mob: item.status === 'Atendimento',
                    cor_atendimento_apos_45_mob:
                      item.status === 'Atendimento Excedido',
                    cor_aguardando_atendimento_mob:
                      item.status === 'Aguardando Atendimento',
                    cor_atendimento_agendado_mob:
                      item.status === 'Atendimento Agendado',
                    cor_fila_mob: item.status === 'Fila de Espera'
                  }"
                >
                  <td class="fw-bold">{{ item.id }}</td>
                  <td
                    class="text-truncate"
                    style="max-width: 120px"
                    :title="item.cliente"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    class="text-truncate"
                    style="max-width: 100px"
                    :title="item.modelo"
                  >
                    {{ item.modelo }}
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="{
                        cor_venda_finalizada_mob:
                          item.status === 'Venda Finalizada',
                        cor_venda_perdida_mob: item.status === 'Venda Perdida',
                        cor_aguardando_aprovacao_mob:
                          item.status === 'Aguardando Aprovação',
                        cor_em_atendimento_mob: item.status === 'Atendimento',
                        cor_atendimento_apos_45_mob:
                          item.status === 'Atendimento Excedido',
                        cor_aguardando_atendimento_mob:
                          item.status === 'Aguardando Atendimento',
                        cor_atendimento_agendado_mob:
                          item.status === 'Atendimento Agendado',
                        cor_fila_mob: item.status === 'Fila de Espera'
                      }"
                    >
                      {{ abbreviateStatus(item.status) }}
                    </span>
                  </td>
                  <td class="fw-semibold">{{ item.total_atendimento }}</td>
                  <td>{{ formatDateTablet(item.data_atendimento) }}</td>
                  <td class="text-end">
                    <div class="dropdown">
                      <button
                        class="btn btn-sm btn-modal dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="bi bi-three-dots-vertical"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <!-- 1. Abrir Proposta -->
                        <li
                          v-if="
                            ![
                              'Venda Finalizada',
                              'Venda Perdida',
                              'Aguardando Aprovação',
                              'Fila de Espera'
                            ].includes(item.status)
                          "
                        >
                          <button
                            class="dropdown-item d-flex align-items-center gap-2"
                            @click="abrir_proposta(item.id)"
                          >
                            <i class="bi bi-plus-circle"></i>
                            <span>Abrir Proposta</span>
                          </button>
                        </li>

                        <li v-if="statusPermiteLiberarVendedor(item)">
                          <button
                            class="dropdown-item d-flex align-items-center gap-2"
                            :disabled="vendedorJaLiberado(item)"
                            @click="abrirModalLiberarVendedor(item)"
                            :title="tituloLiberarVendedor(item)"
                          >
                            <i class="bi bi-unlock"></i>
                            <span>Liberar Vendedor</span>
                          </button>
                        </li>

                        <!-- 2. Informações do DES -->
                        <!-- <li v-if="item.cpfCnpj">
                          <button
                            class="dropdown-item d-flex align-items-center gap-2"
                            data-bs-toggle="modal"
                            data-bs-target="#infoDes"
                            @click="info_des(item)"
                          >
                            <i class="bi bi-person-vcard-fill"></i>
                            <span>Info DES</span>
                          </button>
                        </li> -->

                        <!-- 3. Reimprimir Menu - APENAS QUANDO PODE -->
                        <li v-if="podeReimprimir(item)">
                          <a
                            class="dropdown-item d-flex align-items-center gap-2"
                            :href="`/desk/menu/reimprimirGerente/${item.id}`"
                          >
                            <i class="bi bi-printer"></i>
                            <span>Reimprimir</span>
                          </a>
                        </li>

                        <!-- Mensagem quando NÃO pode reimprimir -->
                        <li v-else class="px-3 py-2 text-muted small">
                          <div class="d-flex align-items-center gap-1">
                            <i class="bi bi-info-circle"></i>
                            <span>{{ getMensagemReimpressao(item) }}</span>
                          </div>
                        </li>

                        <!-- 4. Trocar Vendedor -->
                        <li
                          v-if="
                            ![
                              'Venda Finalizada',
                              'Venda Perdida',
                              'Fila de Espera',
                              'Atendimento Agendado'
                            ].includes(item.status)
                          "
                        >
                          <button
                            class="dropdown-item d-flex align-items-center gap-2"
                            data-bs-toggle="modal"
                            data-bs-target="#trocarVendedor"
                            @click="listar_vendedores(item)"
                          >
                            <i class="bi bi-person-bounding-box"></i>
                            <span>Trocar Vendedor</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Desktop (≥992px): Tabela Completa -->
        <div class="d-none d-lg-block">
          <table class="table mt-2 linha">
            <thead>
              <tr>
                <th scope="col">Nº Atendimento</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Cliente</th>
                <th scope="col">Modelo</th>
                <th scope="col">Categoria</th>
                <th scope="col">Inicio Atendimento</th>
                <th scope="col">Data Atendimento</th>
                <th scope="col">Gerados</th>
                <th scope="col">Retorno</th>
                <th scope="col">Status</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in propostas_at"
                :key="item.id"
                class="table-linha"
                :class="{
                  cor_aguardando_atendimento:
                    item.status === 'Aguardando Atendimento',
                  cor_atendimento_agendado:
                    item.status === 'Atendimento Agendado',
                  cor_aprovacao: item.status === 'Aguardando Aprovação',
                  cor_em_atendimento: item.status === 'Atendimento',
                  cor_atendimento_apos_45:
                    item.status === 'Atendimento Excedido',
                  cor_venda_finalizada: item.status === 'Venda Finalizada',
                  cor_venda_perdida: item.status === 'Venda Perdida',
                  cor_fila: item.status === 'Fila de Espera'
                }"
              >
                <td class="rf_header_table">{{ item.id }}</td>
                <td class="rf_header_table">{{ item.vendedor }}</td>
                <td class="rf_header_table">{{ item.cliente }}</td>
                <td class="rf_header_table">{{ item.modelo }}</td>
                <td class="rf_header_table">
                  {{ item.tipo_veiculo === 0 ? "Novo" : "Usado" }}
                </td>
                <td class="rf_header_table">{{ item.total_atendimento }}</td>
                <td class="rf_header_table">{{ item.data_atendimento }}</td>
                <td class="rf_header_table">
                  {{ item.quantidade_proposta_menu }}
                </td>
                <td class="rf_header_table">{{ item.retorno }}</td>
                <td class="rf_header_table">{{ item.status }}</td>

                <td>
                  <!-- 1. Abrir Proposta -->
                  <button
                    type="button"
                    class="btn-desk"
                    v-bind:disabled="
                      item.status === 'Venda Finalizada' ||
                      item.status === 'Venda Perdida' ||
                      item.status === 'Aguardando Aprovação' ||
                      item.status === 'Fila de Espera'
                    "
                    @click="abrir_proposta(item.id)"
                    title="Abrir Proposta"
                  >
                    <i class="bi bi-plus-circle"></i>
                  </button>

                  <button
                    v-if="statusPermiteLiberarVendedor(item)"
                    type="button"
                    class="btn-desk"
                    :disabled="vendedorJaLiberado(item)"
                    @click="abrirModalLiberarVendedor(item)"
                    :title="tituloLiberarVendedor(item)"
                  >
                    <i class="bi bi-unlock"></i>
                  </button>

                  <!-- 2. Informações do DES -->
                  <button
                    type="button"
                    class="btn-desk"
                    data-bs-toggle="modal"
                    data-bs-target="#infoDes"
                    :disabled="!item.cpfCnpj"
                    @click="info_des(item)"
                    title="Informações do Des"
                  >
                    <i class="bi bi-person-vcard-fill"></i>
                  </button>

                  <!-- 3. Reimprimir Menu -->
                  <button
                    type="button"
                    class="btn-desk"
                    v-bind:disabled="
                      item.status === 'Aguardando Aprovação' ||
                      item.status === 'Aguardando Atendimento' ||
                      item.status === 'Atendimento' ||
                      item.status === 'Atendimento Excedido' ||
                      item.status === 'Fila de Espera' ||
                      item.status === 'Atendimento Agendado'
                    "
                    title="Reimprimir"
                  >
                    <router-link
                      class="nav-link active"
                      :to="`/desk/menu/reimprimirGerente/${item.id}`"
                    >
                      <i class="bi bi-printer"></i>
                    </router-link>
                  </button>

                  <!-- 4. Trocar Vendedor -->
                  <button
                    type="button"
                    class="btn-desk"
                    data-bs-toggle="modal"
                    data-bs-target="#trocarVendedor"
                    v-bind:disabled="
                      item.status === 'Venda Finalizada' ||
                      item.status === 'Venda Perdida' ||
                      item.status === 'Fila de Espera' ||
                      item.status === 'Atendimento Agendado'
                    "
                    @click="listar_vendedores(item)"
                    title="Trocar Vendedor"
                  >
                    <i class="bi bi-person-bounding-box"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="abrir_modal">
      <Message :msg="msg" v-show="msg" />
    </div>

    <div
      v-if="modalLiberarVendedor"
      class="modal"
      tabindex="-1"
      style="display: block"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-unlock icon-text-logout"></i>
            <span class="txt-title-modal">Liberar vendedor</span>
            <button
              class="btn-close"
              type="button"
              @click="fecharModalLiberarVendedor"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <p class="txt-form-input fw-bold">
              Deseja liberar o vendedor deste atendimento para novos
              atendimentos?
            </p>
            <p class="txt-form-input">
              Atendimento:
              {{
                atendimentoLiberarVendedor ? atendimentoLiberarVendedor.id : ""
              }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-form"
              @click="confirmarLiberarVendedor"
            >
              Liberar
            </button>
            <button
              type="button"
              class="btn btn-form"
              @click="fecharModalLiberarVendedor"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modalPausarVendedor"
      class="modal"
      tabindex="-1"
      style="display: block"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pause-circle icon-text-logout"></i>
            <span class="txt-title-modal">Pausar vendedor</span>
            <button
              class="btn-close"
              type="button"
              @click="fecharModalPausarVendedor"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <span class="txt-form-input fw-bold">
              Informe o motivo da pausa do vendedor.
            </span>
            <p class="txt-form-input">
              Vendedor:
              {{
                vendedorPausar && vendedorPausar.vendedor
                  ? vendedorPausar.vendedor.username
                  : ""
              }}
            </p>
            <textarea
              v-model="motivoPausaVendedor"
              class="form-control mt-5"
              rows="3"
              placeholder="Motivo da pausa"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-form"
              @click="confirmarPausarVendedor"
            >
              Pausar
            </button>
            <button
              type="button"
              class="btn btn-form"
              @click="fecharModalPausarVendedor"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modalDespausarVendedor"
      class="modal"
      tabindex="-1"
      style="display: block"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-play-circle icon-text-logout"></i>
            <span class="txt-title-modal">Retornar vendedor</span>
            <button
              class="btn-close"
              type="button"
              @click="fecharModalDespausarVendedor"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <p class="txt-form-input fw-bold">
              Deseja retornar este vendedor para o fim da fila?
            </p>
            <p class="txt-form-input">
              Vendedor:
              {{
                vendedorDespausar && vendedorDespausar.vendedor
                  ? vendedorDespausar.vendedor.username
                  : ""
              }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-form"
              @click="confirmarDespausarVendedor"
            >
              Retornar
            </button>
            <button
              type="button"
              class="btn btn-form"
              @click="fecharModalDespausarVendedor"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação (MANTIDO apenas para contexto, mas sem ações de aprovar/reprovar) -->
    <div
      class="modal fade"
      id="confirmationModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-info-circle icon-text-logout"></i>
            <span class="txt-title-modal">Confirmação</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <!-- Conteúdo genérico -->
          </div>
          <div class="modal-footer">
            <!-- Botões responsivos genéricos -->
            <div
              class="d-md-none d-flex flex-wrap justify-content-around w-100"
            >
              <button
                type="button"
                class="round-btn"
                data-bs-dismiss="modal"
                title="Cancelar"
              >
                <i class="bi bi-x-circle"></i>
              </button>
              <button type="button" class="round-btn" title="Confirmar">
                <i class="bi bi-check2-circle"></i>
              </button>
            </div>

            <div class="d-none d-md-flex gap-2 w-100">
              <button
                type="button"
                class="btn btn-form flex-grow-1"
                data-bs-dismiss="modal"
              >
                <i class="bi bi-x-circle me-2"></i>
                <span>Cancelar</span>
              </button>
              <button type="button" class="btn btn-form flex-grow-1">
                <i class="bi bi-check2-circle me-2"></i>
                <span>Confirmar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Trocar Vendedor (MANTIDO - uma das 4 ações) -->
    <div
      class="modal fade"
      id="trocarVendedor"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-info-circle icon-text-logout"></i>
            <span class="txt-title-modal">Trocar Vendedor</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <form @submit.prevent="onSubmitTrocaVendedor">
              <div class="row g-2 p-2">
                <!-- Vendedor -->
                <div class="col-12">
                  <div class="form-floating txt-form-label">
                    <select
                      class="form-select txt-form-input"
                      v-model="vendedor_final"
                      required
                    >
                      <option
                        v-for="item in vendedor.rows"
                        :value="item.vendedor_id"
                        :key="item.id"
                      >
                        {{ item.vendedor.username }}
                      </option>
                    </select>
                    <label>Vendedor</label>
                  </div>
                </div>

                <!-- Justificativa -->
                <div class="col-12">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="justificativa_vendedor"
                      list="justificativasList"
                      autocomplete="off"
                      required
                    />
                    <label>Justificativa</label>
                    <datalist id="justificativasList">
                      <option value="vendedor ausente"></option>
                      <option value="vendedor em TestDrive"></option>
                      <option value="vendedor em atendimento"></option>
                      <option value="cliente solicitou a troca"></option>
                    </datalist>
                  </div>
                </div>
              </div>

              <!-- Botões responsivos -->
              <div class="modal-footer">
                <!-- Mobile: ícones -->
                <div
                  class="d-md-none d-flex flex-wrap justify-content-around w-100"
                >
                  <button
                    type="button"
                    class="round-btn"
                    data-bs-dismiss="modal"
                    title="Cancelar"
                  >
                    <i class="bi bi-x-circle"></i>
                  </button>
                  <button type="submit" class="round-btn" title="Confirmar">
                    <i class="bi bi-check2-circle"></i>
                  </button>
                </div>

                <!-- Tablet/Desktop: botões com texto -->
                <div class="d-none d-md-flex gap-2 w-100">
                  <button
                    type="button"
                    class="btn btn-form flex-grow-1"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle me-2"></i>
                    <span>Cancelar</span>
                  </button>
                  <button type="submit" class="btn btn-form flex-grow-1">
                    <i class="bi bi-check2-circle me-2"></i>
                    <span>Confirmar</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Justificativa (MANTIDO - para reordenar vendedores) -->
    <div class="modal fade" id="justificativaModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <i class="bi bi-info-circle icon-text-logout"></i>
            <span class="txt-title-modal">Justificativa para Reordenação</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="justificativaInput" class="form-label">
                Explique por que está reordenando os vendedores (mínimo 20
                caracteres):
              </label>
              <textarea
                class="form-control"
                id="justificativaInput"
                rows="3"
                v-model="justificativa"
                :class="{
                  'is-invalid': justificativa && justificativa.length < 20
                }"
              ></textarea>
              <div class="invalid-feedback">
                A justificativa deve ter pelo menos 20 caracteres
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-lg btn-form"
              data-bs-dismiss="modal"
              @click="recarregarPagina"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-lg btn-form"
              @click="confirmarReordenacao"
              :disabled="!justificativa || justificativa.length < 20"
            >
              Confirmar Reordenação
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Informações do Des (MANTIDO - uma das 4 ações) -->
    <div
      class="modal fade"
      id="infoDes"
      tabindex="-1"
      aria-labelledby="infoDesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="infoDesLabel">
              <i class="bi bi-person-badge me-2"></i>
              Informações do Cliente - DES
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- Mantém o conteúdo original do modal infoDes -->
          <div class="modal-body">
            <!-- Loading -->
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Buscando informações do cliente...</p>
            </div>
            <!-- Dados do Cliente -->
            <div v-else-if="clienteData" class="container-fluid">
              <!-- Cabeçalho com informações principais -->
              <div class="row mb-4">
                <div class="col-md-8">
                  <h4 class="text-primary">{{ clienteData.customer.name }}</h4>
                  <p class="mb-1">
                    <strong>CPF:</strong>
                    {{ formatCpf(clienteData.customer.cpf_cnpj) }}
                  </p>
                  <div class="d-flex align-items-center gap-4 flex-wrap mt-1">
                    <!-- Ranking -->
                    <div class="d-flex align-items-center gap-1">
                      <strong>Ranking:</strong>

                      <span class="badge bg-warning">
                        {{ clienteData.ranking.toFixed(2) }}%
                      </span>
                    </div>

                    <!-- Oportunidades -->
                    <div class="d-flex align-items-center gap-2">
                      <strong>Oportunidades:</strong>

                      <div
                        class="d-inline-flex gap-1 flex-wrap align-items-center"
                      >
                        <div
                          v-for="code in parseOpportunityCodes(
                            clienteData.opportunityTypeCodes
                          )"
                          :key="code"
                          class="opportunity-badge"
                          :style="{
                            backgroundColor: getOpportunityColor(code)
                          }"
                        >
                          {{ code }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 text-end">
                  <p class="mb-1">
                    <small class="text-muted"
                      >Atualizado em:
                      {{ formatDate(clienteData.customer.dt_update) }}</small
                    >
                  </p>
                </div>
              </div>

              <!-- Abas de Navegação -->
              <ul class="nav nav-tabs" id="clienteTabs" role="tablist">
                <li class="nav-item-des" role="presentation">
                  <button
                    class="nav-link active"
                    id="dados-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#dados"
                    type="button"
                    role="tab"
                  >
                    <i class="bi bi-person me-1"></i>Dados Pessoais
                  </button>
                </li>
                <li class="nav-item-des" role="presentation">
                  <button
                    class="nav-link"
                    id="vendas-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#vendas"
                    type="button"
                    role="tab"
                  >
                    <i class="bi bi-cart-check me-1"></i>Histórico de Vendas ({{
                      clienteData.historySales.length
                    }})
                  </button>
                </li>
                <li class="nav-item-des" role="presentation">
                  <button
                    class="nav-link"
                    id="servicos-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#servicos"
                    type="button"
                    role="tab"
                  >
                    <i class="bi bi-tools me-1"></i>Histórico de Serviços ({{
                      clienteData.historyServices.length
                    }})
                  </button>
                </li>
                <li class="nav-item-des" role="presentation">
                  <button
                    class="nav-link"
                    id="financiamento-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#financiamento"
                    type="button"
                    role="tab"
                  >
                    <i class="bi bi-cash-coin me-1"></i>Histórico Financeiro
                  </button>
                </li>
              </ul>

              <!-- Conteúdo das Abas -->
              <div
                class="tab-content p-3 border border-top-0 rounded-bottom"
                id="clienteTabsContent"
              >
                <!-- Aba: Dados Pessoais -->
                <div
                  class="tab-pane fade show active"
                  id="dados"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <h6><i class="bi bi-telephone me-2"></i>Contatos</h6>
                      <table class="table table-sm">
                        <tr>
                          <td><strong>Celular:</strong></td>
                          <td>{{ clienteData.customer.phone_cel || "N/A" }}</td>
                        </tr>
                        <tr>
                          <td><strong>Comercial:</strong></td>
                          <td>{{ clienteData.customer.phone_com || "N/A" }}</td>
                        </tr>
                        <tr>
                          <td><strong>Residencial:</strong></td>
                          <td>{{ clienteData.customer.phone_res || "N/A" }}</td>
                        </tr>
                        <tr>
                          <td><strong>Email:</strong></td>
                          <td>{{ clienteData.customer.email || "N/A" }}</td>
                        </tr>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <h6><i class="bi bi-geo-alt me-2"></i>Endereço</h6>
                      <table class="table table-sm">
                        <tr>
                          <td><strong>Endereço:</strong></td>
                          <td>{{ clienteData.customer.address || "N/A" }}</td>
                        </tr>
                        <tr>
                          <td><strong>Complemento:</strong></td>
                          <td>
                            {{ clienteData.customer.address_compl || "N/A" }}
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Bairro:</strong></td>
                          <td>
                            {{ clienteData.customer.address_district || "N/A" }}
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Cidade/UF:</strong></td>
                          <td>
                            {{ clienteData.customer.address_state || "N/A" }}
                          </td>
                        </tr>
                        <tr>
                          <td><strong>CEP:</strong></td>
                          <td>
                            {{ clienteData.customer.address_zipcode || "N/A" }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Aba: Histórico de Serviços -->
                <div class="tab-pane fade" id="servicos" role="tabpanel">
                  <div class="table-responsive">
                    <table class="table table-sm table-striped">
                      <thead class="table-light">
                        <tr>
                          <th>Data</th>
                          <th>Veículo</th>
                          <th>Placa</th>
                          <th>Serviço</th>
                          <th>Consultor</th>
                          <th>KM</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="servico in clienteData.historyServices"
                          :key="servico.num_os"
                        >
                          <td>{{ formatDate(servico.dt_service) }}</td>
                          <td>
                            <small>
                              {{ servico.model }}<br />
                              <span class="text-muted"
                                >{{ servico.year_fab }}/{{
                                  servico.year_mod
                                }}</span
                              >
                            </small>
                          </td>
                          <td>{{ servico.plate }}</td>
                          <td>
                            <strong>{{ servico.service_description }}</strong
                            ><br />
                            <small class="text-muted">{{
                              servico.os_description
                            }}</small>
                          </td>
                          <td>{{ servico.consultant }}</td>
                          <td>{{ servico.km?.toLocaleString() || "N/A" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Aba: Histórico de Vendas -->
                <div class="tab-pane fade" id="vendas" role="tabpanel">
                  <div class="table-responsive">
                    <table class="table table-sm table-striped">
                      <thead class="table-light">
                        <tr>
                          <th>Data</th>
                          <th>Veículo</th>
                          <th>Placa</th>
                          <th>Valor Venda</th>
                          <th>Forma Pagamento</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="venda in clienteData.historySales"
                          :key="venda.proposal"
                        >
                          <td>{{ formatDate(venda.dt_invoice) }}</td>
                          <td>
                            <small>
                              {{ venda.brand }} {{ venda.model }}<br />
                              <span class="text-muted"
                                >{{ venda.year_fab }}/{{ venda.year_mod }}</span
                              >
                            </small>
                          </td>
                          <td>{{ venda.plate }}</td>
                          <td>
                            <strong
                              >R$
                              {{
                                venda.value_sales?.toLocaleString("pt-BR")
                              }}</strong
                            ><br />
                            <small class="text-muted"
                              >Compra: R$
                              {{
                                venda.value_purchase?.toLocaleString("pt-BR")
                              }}</small
                            >
                          </td>
                          <td>{{ venda.payment_type }}</td>
                          <td>
                            <span
                              :class="
                                venda.status_sales
                                  ? 'badge bg-success'
                                  : 'badge bg-secondary'
                              "
                            >
                              {{ venda.status_sales ? "Ativa" : "Inativa" }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Aba: Histórico de Financiamento -->
                <div class="tab-pane fade" id="financiamento" role="tabpanel">
                  <div class="table-responsive">
                    <table class="table table-sm table-striped align-middle">
                      <thead class="table-light">
                        <tr>
                          <th>Data</th>
                          <th>Veículo</th>
                          <th>Tipo</th>
                          <th>Banco</th>
                          <th>Valor Financiado</th>
                          <th>Entrada</th>
                          <th>Parcelas</th>
                          <th>Valor Parcela</th>
                          <th>Coef.</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="venda in financingHistory"
                          :key="`${venda.proposal}-${venda.chassi}`"
                        >
                          <!-- DATA -->
                          <td>
                            {{ formatDate(venda.dt_invoice) }}
                          </td>

                          <!-- VEÍCULO -->
                          <td>
                            <small>
                              <strong>
                                {{ venda.brand }} {{ venda.model }}
                              </strong>

                              <br />

                              <span class="text-muted">
                                {{ venda.year_fab }}/{{ venda.year_mod }}
                              </span>
                            </small>
                          </td>

                          <!-- TIPO -->
                          <td>
                            <span class="badge bg-success">
                              {{
                                venda.paymentDetails?.typeCode ||
                                venda.payment_type ||
                                "FINANCIAMENTO"
                              }}
                            </span>
                          </td>
                             <td>
                            <span class="badge bg-success">
                              {{
                                venda.paymentDetails?.bank ||
                                ""
                              }}
                            </span>
                          </td>

                          <!-- VALOR FINANCIADO -->
                          <td>
                            <strong>
                              {{
                                currency(
                                  venda.paymentDetails?.financedValue ??
                                  venda.financ_value ??
                                  0
                                )
                              }}
                            </strong>
                          </td>

                          <!-- ENTRADA -->
                          <td>

                            {{
                              currency(
                                venda.paymentDetails?.downpayment ??
                                venda.financ_downpayment ??
                                0
                              )
                            }}
                          </td>

                          <!-- PARCELAS -->
                          <td>
                            {{
                              venda.paymentDetails?.installmentsTotal ??
                              venda.financ_qt_month ??
                              "-"
                            }}x
                          </td>

                          <!-- VALOR PARCELA -->
                          <td>
                            R$
                            {{
                              (
                                venda.paymentDetails?.installmentValue ??
                                venda.financ_value_month ??
                                0
                              ).toLocaleString("pt-BR")
                            }}
                          </td>

                          <!-- COEFICIENTE -->
                          <td>
                            {{
                              (venda.paymentDetails?.coef ??
                                venda.financ_coef) ||
                              "-"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mensagem de erro -->
            <div v-else-if="error" class="alert alert-danger text-center">
              <i class="bi bi-exclamation-triangle me-2"></i>
              {{ error }}
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import userService from "../../services/user.service";
import { VueMaskDirective } from "vue-the-mask";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import Message from "../../components/modal/Message.vue";
import axios from "axios";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";
import DraggableTableVue from "../../components/DraggableTable.vue";
import DraggableTableVueMob from "../../components/DraggableTableMob.vue";
import { Modal } from "bootstrap";
import {
  getOpportunityColor,
  parseOpportunityCodes
} from "../../util/desOpportunityColors";

export default {
  name: "AdministracaoDesk",

  components: {
    SidebarVue,
    NavgatorDk,
    Message,
    RodapeVue,
    DraggableTableVueMob,
    DraggableTableVue
  },

  directives: {
    mask: VueMaskDirective
  },

  data() {
    return {
      // Dados principais
      usuarios_dispo: [],
      propostas_at: [],
      vendedor: [],
      clienteData: null,

      // Estados e mensagens
      loading: false,
      abrir_modal: false,
      modalLiberarVendedor: false,
      atendimentoLiberarVendedor: null,
      modalPausarVendedor: false,
      vendedorPausar: null,
      motivoPausaVendedor: "",
      modalDespausarVendedor: false,
      vendedorDespausar: null,
      msg: "",
      error: null,

      // Filtros
      selectedFilter: "",
      startDate: "",
      endDate: "",
      status_proposta: "",
      data_ini: "",
      data_fim: "",

      // Modal Trocar Vendedor
      vendedor_final: "",
      vendedor_id_atual: "",
      justificativa_vendedor: "",
      id_proposta: "",

      // Modal Justificativa Reordenação
      justificativa: "",
      novaOrdemPendente: null,
      vendedorMovidoReordenacao: null,

      // IDs e autenticação
      empresaID: "",
      company_id: "",
      user_id: "",
      user_log: "",

      // Paginação
      page_disp: 1,
      pageSize_disp: 100,
      tipo_veiculo: "NOVO"
    };
  },

  computed: {
    screen() {
      const width = window.innerWidth;
      return {
        sm: width < 768,
        md: width >= 768 && width < 992,
        lg: width >= 992
      };
    },
    financingHistory() {
      if (!this.clienteData?.historySales) {
        return [];
      }

      return this.clienteData.historySales.filter((venda) => {
        const paymentType = venda.payment_type?.toUpperCase() || "";

        const paymentDetailsType =
          venda.paymentDetails?.type?.toUpperCase() || "";

        return (
          Number(venda.financ_value) > 0 ||
          Number(venda.financ_qt_month) > 0 ||
          Number(venda.financ_value_month) > 0 ||
          paymentType.includes("FINANCIAMENTO") ||
          paymentDetailsType.includes("FINANCIAMENTO")
        );
      });
    }
  },

  created() {
    const accessToken = TokenService.getLocalAccessToken();
    const decodedToken = jwt_decode(accessToken);
    this.empresaID = decodedToken.company;
    this.company_id = decodedToken.company;
    this.user_id = decodedToken.id;

    const user_log = TokenService.getUser();
    this.user_log = user_log.id;
  },

  mounted() {
    this.retrievePropostas();
    this.retrieveVendedorDispo();
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    getOpportunityColor,
    parseOpportunityCodes,
    // Método para verificar se pode reimprimir
    podeReimprimir(item) {
      const statusProibidos = [
        "Aguardando Aprovação",
        "Aguardando Atendimento",
        "Atendimento",
        "Atendimento Excedido",
        "Fila de Espera",
        "Atendimento Agendado"
      ];

      return (
        item.quantidade_proposta_menu > 0 &&
        !statusProibidos.includes(item.status)
      );
    },

    // Método para mensagem de feedback
    getMensagemReimpressao(item) {
      if (item.quantidade_proposta_menu === 0) {
        return "Nenhum menu gerado";
      }

      const statusProibidos = [
        "Aguardando Aprovação",
        "Aguardando Atendimento",
        "Atendimento",
        "Atendimento Excedido",
        "Fila de Espera",
        "Atendimento Agendado"
      ];

      if (statusProibidos.includes(item.status)) {
        return `Não disponível para status: ${item.status}`;
      }

      return "Reimprimir menu";
    },

    statusPermiteLiberarVendedor(item) {
      if (item.status === "Aguardando Atendimento") {
        return true;
      }

      if (
        item.status === "Atendimento" ||
        item.status === "Atendimento Excedido"
      ) {
        return this.propostas_at.some((proposta) => {
          return (
            proposta.id !== item.id &&
            Number(proposta.vendedor_id) === Number(item.vendedor_id) &&
            proposta.status === "Aguardando Atendimento"
          );
        });
      }

      return false;
    },

    vendedorJaLiberado(item) {
      if (this.vendedorEstaPausado(item)) {
        return true;
      }

      return [
        "Venda Finalizada",
        "Venda Perdida",
        "Aguardando Aprovação"
      ].includes(item.status);
    },

    vendedorEstaPausado(item) {
      return this.usuarios_dispo.some((vendedor) => {
        return (
          Number(vendedor.vendedor_id) === Number(item.vendedor_id) &&
          vendedor.liberado_gerente === 3
        );
      });
    },

    tituloLiberarVendedor(item) {
      return this.vendedorEstaPausado(item)
        ? "Vendedor pausado"
        : "Liberar Vendedor";
    },

    // =============== 4 AÇÕES PRINCIPAIS ===============

    // 1. Abrir Proposta
    async abrir_proposta(id) {
      try {
        this.$router.push(`/desk/menu/proposta/${id}`);
      } catch (error) {
        console.error("Erro ao redirecionar:", error);
        this.showMessage("Erro ao abrir proposta");
      }
    },

    abrirModalLiberarVendedor(item) {
      this.atendimentoLiberarVendedor = item;
      this.modalLiberarVendedor = true;
    },

    fecharModalLiberarVendedor() {
      this.modalLiberarVendedor = false;
      this.atendimentoLiberarVendedor = null;
    },

    async confirmarLiberarVendedor() {
      if (!this.atendimentoLiberarVendedor) return;

      try {
        await axios.put(
          `${process.env.VUE_APP_API_URL}grupobeni/liberar_vendedor_atendimento/${this.atendimentoLiberarVendedor.id}`
        );
        this.showMessage("Vendedor liberado com sucesso!");
        this.fecharModalLiberarVendedor();
        this.retrieveVendedorDispo();
        this.retrievePropostas();
      } catch (error) {
        console.error("Erro ao liberar vendedor:", error);
        this.showMessage("Erro ao liberar vendedor");
      }
    },

    abrirModalPausarVendedor(vendedor) {
      this.vendedorPausar = vendedor;
      this.motivoPausaVendedor = "";
      this.modalPausarVendedor = true;
    },

    fecharModalPausarVendedor() {
      this.modalPausarVendedor = false;
      this.vendedorPausar = null;
      this.motivoPausaVendedor = "";
    },

    async confirmarPausarVendedor() {
      if (!this.vendedorPausar) return;

      if (!this.motivoPausaVendedor.trim()) {
        this.showMessage("Informe o motivo da pausa do vendedor");
        return;
      }

      try {
        await axios.put(
          `${process.env.VUE_APP_API_URL}grupobeni/pausar_vendedor/${this.vendedorPausar.id}`,
          {
            gerente_id: this.user_id,
            justificativa: this.motivoPausaVendedor.trim()
          }
        );

        this.showMessage("Vendedor pausado com sucesso!");
        this.fecharModalPausarVendedor();
        this.retrieveVendedorDispo();
      } catch (error) {
        console.error("Erro ao pausar vendedor:", error);
        this.showMessage(
          error.response?.data?.message || "Erro ao pausar vendedor"
        );
      }
    },

    abrirModalDespausarVendedor(vendedor) {
      this.vendedorDespausar = vendedor;
      this.modalDespausarVendedor = true;
    },

    fecharModalDespausarVendedor() {
      this.modalDespausarVendedor = false;
      this.vendedorDespausar = null;
    },

    async confirmarDespausarVendedor() {
      if (!this.vendedorDespausar) return;

      try {
        await axios.put(
          `${process.env.VUE_APP_API_URL}grupobeni/despausar_vendedor/${this.vendedorDespausar.id}`
        );

        this.showMessage("Vendedor retornou para o fim da fila!");
        this.fecharModalDespausarVendedor();
        this.retrieveVendedorDispo();
      } catch (error) {
        console.error("Erro ao retornar vendedor:", error);
        this.showMessage(
          error.response?.data?.message || "Erro ao retornar vendedor"
        );
      }
    },

    avisarReordenacaoPausado() {
      this.showMessage("Não é possível reordenar um vendedor pausado");
      this.retrieveVendedorDispo();
    },

    // 2. Informações do DES
    async info_des(item) {
      try {
        this.loading = true;
        this.error = null;
        this.clienteData = null;

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}des/info_cliente/`,
          { params: { cpfCnpj: item.cpfCnpj } }
        );
        console.log("Resposta api", response.data);
        if (response.data.success && response.data.data) {
          this.clienteData = response.data.data;
        } else {
          this.error = "Cliente não encontrado na base de dados";
        }
      } catch (error) {
        console.error("Erro na consulta:", error);
        this.error = "Erro ao buscar informações do cliente";
      } finally {
        this.loading = false;
      }
    },

    // 3. Trocar Vendedor
    async listar_vendedores(item) {
      this.vendedor_id_atual = item.vendedor_id;
      this.id_proposta = item.id;

      try {
        const params = {
          empresa_id: this.company_id,
          id_vend: item.vendedor_id,
          page: 0,
          size: 100
        };

        const response = await userService.getVendedorOrdenado(params);
        this.vendedor = response.data;
      } catch (error) {
        this.showMessage(
          error.response?.data?.message || "Erro ao carregar vendedores"
        );
      }
    },

    async onSubmitTrocaVendedor() {
      if (
        !this.justificativa_vendedor ||
        this.justificativa_vendedor.length < 10
      ) {
        this.showMessage("Justificativa deve ter no mínimo 10 caracteres");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}proposta_troca_vendedor/${this.id_proposta}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: this.id_proposta,
              just_troca_vendedor: this.justificativa_vendedor,
              vendedor_id: this.vendedor_final,
              vendedor_id_trocado: this.vendedor_id_atual
            })
          }
        );

        if (!response.ok) throw new Error("Erro na requisição");

        const data = await response.json();
        if (data.success) {
          this.showMessage("Vendedor trocado com sucesso");
          setTimeout(() => window.location.reload(), 1500);
        }
      } catch (error) {
        console.error("Erro na troca de vendedor:", error);
        this.showMessage("Erro ao processar troca de vendedor");
      }
    },

    // 4. Reimprimir (feito via router-link no template)

    // =============== FILA DE VENDEDORES ===============

    async retrieveVendedorDispo() {
      try {
        const params = {
          empresa_id: this.company_id,
          page: this.page_disp - 1,
          size: this.pageSize_disp
        };

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}grupobeni/listar_vendedores_gerente`,
          { params }
        );
        this.usuarios_dispo = response.data.rows;
      } catch (error) {
        this.showMessage(
          error.response?.data?.message || "Erro ao carregar vendedores"
        );
      }
    },

    atualizarLista(novaLista) {
      this.usuarios_dispo = novaLista;
    },

    async salvarOrdenacao(novaOrdem, vendedorMovidoId = null) {
      try {
        const vendedorPausadoMovido = novaOrdem.some((vendedor, index) => {
          return (
            vendedor.liberado_gerente === 3 && vendedor.ordem !== index + 1
          );
        });

        if (vendedorPausadoMovido) {
          this.showMessage("Vendedor pausado não pode ser reordenado");
          this.retrieveVendedorDispo();
          return;
        }

        this.novaOrdemPendente = novaOrdem;
        this.vendedorMovidoReordenacao = vendedorMovidoId;
        const modalElement = document.getElementById("justificativaModal");
        const modalInstance = new Modal(modalElement);
        modalInstance.show();
      } catch (error) {
        console.error("Erro ao preparar reordenação:", error);
        this.showMessage("Erro ao iniciar reordenação");
      }
    },

    async confirmarReordenacao() {
      try {
        if (!this.justificativa || this.justificativa.length < 20) {
          this.showMessage("Justificativa deve ter no mínimo 20 caracteres");
          return;
        }

        const vendedoresAtivos = this.novaOrdemPendente.filter((vendedor) => {
          return vendedor.liberado_gerente !== 3;
        });

        const payload = {
          novaOrdem: vendedoresAtivos.map((vendedor, index) => ({
            id: vendedor.id,
            gerente_id: this.user_id,
            ordem_anterior: vendedor.ordem || 0,
            nova_ordem: index + 1
          })),
          justificativa: this.justificativa,
          vendedor_movido_id: this.vendedorMovidoReordenacao
        };

        const response = await fetch(
          `${process.env.VUE_APP_API_URL}reordenar_vendedores`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) throw new Error("Erro na requisição");

        this.showMessage("Ordenação salva com sucesso!");
        const modalElement = document.getElementById("justificativaModal");
        const modalInstance = Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }

        setTimeout(() => {
          this.justificativa = "";
          this.novaOrdemPendente = null;
          this.vendedorMovidoReordenacao = null;
          this.retrieveVendedorDispo();
        }, 1500);
      } catch (error) {
        console.error("Erro ao salvar ordenação:", error);
        this.showMessage("Erro ao salvar ordenação");
      }
    },

    recarregarPagina() {
      window.location.reload();
    },

    moverCima(vendedorId) {
      const index = this.usuarios_dispo.findIndex((v) => v.id === vendedorId);
      if (index > 0) {
        [this.usuarios_dispo[index], this.usuarios_dispo[index - 1]] = [
          this.usuarios_dispo[index - 1],
          this.usuarios_dispo[index]
        ];
        this.salvarOrdenacao(this.usuarios_dispo);
      }
    },

    moverBaixo(vendedorId) {
      const index = this.usuarios_dispo.findIndex((v) => v.id === vendedorId);
      if (index < this.usuarios_dispo.length - 1) {
        [this.usuarios_dispo[index], this.usuarios_dispo[index + 1]] = [
          this.usuarios_dispo[index + 1],
          this.usuarios_dispo[index]
        ];
        this.salvarOrdenacao(this.usuarios_dispo);
      }
    },

    // =============== ATENDIMENTOS (PROPOSTAS) ===============

    filtrarPropostas() {
      if (
        [
          "Em Atendimento",
          "Venda Finalizada",
          "Venda Perdida",
          "Todos",
          "Dia"
        ].includes(this.selectedFilter)
      ) {
        this.status_proposta = this.selectedFilter;
        this.retrievePropostas();
      }
    },

    filterByPeriod() {
      this.data_ini = this.startDate;
      this.data_fim = this.endDate;
      this.status_proposta = "Pesquisa Periodo";
      this.retrievePropostas();
    },

    async retrievePropostas(page = 1) {
      try {
        const params = {
          empresa_id: this.empresaID,
          user_id: this.user_id,
          status_proposta: this.status_proposta,
          data_ini: this.data_ini,
          data_fim: this.data_fim,
          tipo_veiculo: this.tipo_veiculo,
          page: page - 1,
          size: 100
        };

        const response = await userService.getPropostaGerente(params);
        const { rows } = response.data.data;

        // Processa quantidade de menus gerados
        const propostaIDs = rows.map((proposta) => proposta.id);
        const quantidadePropostaMenu = await this.getQuantidadePropostaMenu(
          propostaIDs
        );

        // Formata os dados das propostas
        this.propostas_at = await Promise.all(
          rows.map(async (proposta) => {
            const quantidade =
              quantidadePropostaMenu.find((item) => item.id == proposta.id)
                ?.quantidade || 0;
            const nome_vendedor = await this.encontra_vendedor(
              proposta.vendedor_id
            );
            const status = this.determinarStatusCompleto(proposta);
            console.log("Atendimentos", proposta);
            return {
              id: proposta.id,
              vendedor_id: proposta.vendedor_id,
              vendedor: nome_vendedor,
              cliente: proposta.clientes?.nome || "N/A",
              cpfCnpj: proposta.clientes?.cpfCnpj || "",
              modelo: proposta.proposta_veiculo?.modelo_veiculo || "N/A",
              total_atendimento: this.formatDateHora(
                proposta.horario_inicio_atendimento || "00:00:00"
              ),
              data_atendimento: this.formatDate(proposta.createdAt),
              quantidade_proposta_menu: quantidade,
              retorno: proposta.retorno ? "Sim" : "Não",
              status: status, // ⬅️ AGORA COM STATUS CORRETO!
              tipo_veiculo: proposta.tipo_veiculo || 0,
              // Mantém os dados necessários para cálculos
              horario_inicio_atendimento: proposta.horario_inicio_atendimento,
              status_proposta_original: proposta.status_proposta
            };
          })
        );

        this.validando_tempo();
      } catch (error) {
        console.error("Erro ao carregar propostas:", error);
        this.showMessage("Erro ao carregar atendimentos");
      }
    },

    async getQuantidadePropostaMenu(propostaIDs) {
      try {
        const quantidadePromises = propostaIDs.map(async (id) => {
          const response = await userService.getQuantidadePropostaMenuByID(id);
          return {
            id: response.data[0]?.proposta_id || id,
            quantidade: response.data[0]?.count || 0
          };
        });
        return await Promise.all(quantidadePromises);
      } catch (error) {
        return [];
      }
    },

    async encontra_vendedor(id) {
      try {
        if (!id) return "N/A";
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}users/${id}`
        );
        return response.data.username || "N/A";
      } catch (error) {
        return "N/A";
      }
    },

    determinarStatus(statusProposta, proposta = null) {
      // Se não tiver proposta completa, retorna básico
      if (!proposta) {
        const basicMap = {
          Atendimento: "Atendimento",
          "Aguardando Atendimento": "Aguardando Atendimento",
          "Atendimento Agendado": "Atendimento Agendado",
          "Venda Finalizada": "Venda Finalizada",
          "Venda Perdida": "Venda Perdida",
          Aprovação: "Aguardando Aprovação",
          "Fila de Espera": "Fila de Espera"
        };
        return basicMap[statusProposta] || statusProposta;
      }

      // LÓGICA ESPECIAL para "Atendimento" → verificar se excedeu 45min
      if (
        statusProposta === "Atendimento" &&
        proposta.horario_inicio_atendimento
      ) {
        const hora_inicio = new Date(proposta.horario_inicio_atendimento);
        const hora_server = new Date(); // ou usar timestamp atual
        const diferenca_atendimento = Math.abs(
          hora_server.getTime() - hora_inicio.getTime()
        );

        // 2700000 ms = 45 minutos
        if (diferenca_atendimento > 2700000) {
          return "Atendimento Excedido";
        }
      }

      return statusProposta;
    },
    determinarStatusCompleto(proposta) {
      const statusOriginal = proposta.status_proposta;

      // Se for "Atendimento", verificar se excedeu 45min
      if (
        statusOriginal === "Atendimento" &&
        proposta.horario_inicio_atendimento
      ) {
        const hora_inicio = new Date(proposta.horario_inicio_atendimento);
        const agora = new Date();
        const diferenca_ms = Math.abs(agora.getTime() - hora_inicio.getTime());
        const diferenca_minutos = Math.floor(diferenca_ms / (1000 * 60));

        console.log(
          `DEBUG: Atendimento ${proposta.id} - Diferença: ${diferenca_minutos} minutos`
        );

        if (diferenca_minutos > 45) {
          return "Atendimento Excedido";
        }
        return "Atendimento";
      }

      // Mapeamento para outros status
      const statusMap = {
        "Aguardando Atendimento": "Aguardando Atendimento",
        "Atendimento Agendado": "Atendimento Agendado",
        "Venda Finalizada": "Venda Finalizada",
        "Venda Perdida": "Venda Perdida",
        Aprovação: "Aguardando Aprovação",
        "Fila de Espera": "Fila de Espera"
      };

      return statusMap[statusOriginal] || statusOriginal;
    },
    validando_tempo() {
      // Esta função parece atualizar tempos em tempo real
      // Mantida conforme seu código original
      const updateTimes = () => {
        const array_h_2 = this.propostas_at.map((proposta) => {
          let tempo_atendimento = "00:00";
          let tempo_espera = "00:00";

          // Lógica de cálculo de tempo (simplificada)
          if (
            proposta.status === "Atendimento" ||
            proposta.status === "Atendimento Excedido"
          ) {
            tempo_atendimento = "Calculando...";
          }

          if (proposta.status === "Aguardando Atendimento") {
            tempo_espera = "Calculando...";
          }

          return {
            ...proposta,
            tempo_atendimento,
            tempo_espera
          };
        });

        this.propostas_at = array_h_2;
        requestAnimationFrame(updateTimes);
      };

      requestAnimationFrame(updateTimes);
    },

    // =============== UTILITÁRIOS ===============

    abbreviateStatus(status) {
      const abbreviations = {
        "Venda Finalizada": "Finalizada",
        "Venda Perdida": "Perdida",
        "Aguardando Aprovação": "Aprovação",
        Atendimento: "Atend.",
        "Atendimento Excedido": "Excedido",
        "Aguardando Atendimento": "Aguardando",
        "Atendimento Agendado": "Agendado",
        "Fila de Espera": "Fila"
      };
      return abbreviations[status] || status;
    },

    formatDateTablet(dateString) {
      if (!dateString) return "N/A";
      try {
        const [day, month] = dateString.split("/");
        return `${day}/${month}`;
      } catch {
        return dateString;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, "0")}/${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}/${date.getFullYear()}`;
    },
    formatDateHora(dateString) {
      if (!dateString) return "00:00:00";
      if (dateString === "00:00:00") return "00:00:00";

      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return "00:00:00";

      return date.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
    },
    showMessage(message) {
      this.msg = message;
      this.abrir_modal = true;
      setTimeout(() => {
        this.abrir_modal = false;
      }, 4000);
    },

    handleResize() {
      this.$forceUpdate();
    },

    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number || 0);
    },

    formatCpf(cpf) {
      if (!cpf) return "N/A";
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
  }
};
</script>
<style scoped>
.opportunity-badge {
  min-width: 28px;
  height: 28px;

  padding: 0 6px;

  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;

  font-size: 12px;
  font-weight: 700;

  line-height: 1;

  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>
